export class BookingDraftCreationError extends Error {
  readonly cause: unknown

  constructor(cause: unknown) {
    super('Error creating booking draft')
    this.name = 'BookingDraftCreationError'
    this.cause = cause
  }
}
